import RateStyle from "../templates/Rate.style";
var rate = {
  name: 'rate',
  data: [{
    Color: '#FFB040',
    fontSize: 24
  }],
  onlyTemplate: RateStyle
};
export default rate;